<script>
import Grid from '@/components/Grid';
import Spinner from '@/components/Spinner';

export default {
  name: 'data-table',
  components: {
    Grid,
    Spinner,
  },
  props: {
    columns: Array,
    fieldName: String,
    query: Object,
    placeholder: String,
    hideSearch: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    variables: {
      type: Object,
      default: () => ({}),
    },
    onClickHandler: {
      type: Function,
      default: () => {},
    },
    rowClickable: {
      type: Boolean,
      default: false,
    },
    orderable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    paramsJSON() {
      return JSON.stringify(this.params);
    },
  },
  data() {
    return {
      limit: 25,
      page: 0,
      searchResult: '',
      showSpinner: 0,
      data: null,
      items: [],
    };
  },
  render(element) {
    const children = Object.keys(this.$slots).map(slot =>
      element('template', { slot }, this.$slots[slot])
    );
    return this.showSpinner
      ? element('div', { class: 'spinner-wrap' }, [element('spinner')])
      : element(
          'grid',
          {
            props: {
              ...this.$props,
              meta: this.data.meta,
              value: this.items,
              page: this.page,
              limit: this.limit,
              search: this.searchResult,
            },
            scopedSlots: this.$scopedSlots,
            attrs: this.$attrs,
            on: {
              page: this.changePage,
              ordered: this.onOrderChanged, 
              limit: this.changeLimit,
              sort: this.changeSort, 
              change: this.changeSearch,
            }
          },
          children
        );
  },
  apollo: {
    data: {
      query() {
        return this.query;
      },
      fetchPolicy: 'network-only',
      update(data) {
        return data[this.fieldName];
      },
      result({ data, loading }) {
        if (!loading) {
          this.items = data[this.fieldName].result;
        }
      },
      loadingKey: 'showSpinner',
      variables() {
        return {
          ...this.variables,
          limit: parseInt(this.limit),
          page: parseInt(this.page),
          name: this.searchResult,
          where: this.paramsJSON,
          descending: this.descending,
          sortBy: this.sortBy,
        };
      },
    },
  },
  methods: {
    changeSearch(searchResult) {
      this.searchResult = searchResult;
    },
    changeLimit(event) {
      this.limit = +event.target.value;
    },
    changePage(page) {
      this.page = page;
    },
    setFirstPage() {
      this.page = 0;
    },
    changeSort(column) {
      if (column.skipSorting) {
        return;
      }
      this.descending = !this.descending;
      this.sortBy = column.field;
      this.setFirstPage();
    },
    onOrderChanged() {
      const affectedItems = [];
      for (const i in this.items) {
        const item = this.items[i];
        const newOrder = +i + 1;
        if (item.order !== newOrder) {
          this.items[i] = {
            ...item,
            order: newOrder,
          };
          affectedItems.push(this.items[i]);
        }
      }
      this.$emit('ordered', affectedItems);
    },
    onRefreshData() {
      /* eslint-disable dot-notation */
      this.$apollo.queries['data'].refresh();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.spinner-wrap {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/DataTable.vue